import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BookingModel, BookingService, LayoutService, NavigationService } from 'app-components';
import { LocationInfo, PageBase, RentalInfo } from 't4core';
import { AppIntegrationService, AppSettingsService } from 't4-app-integration';
import { LocationMapComponent } from '../../../../lib/Components/location-map/location-map.component';


@Component({
    selector: 'pickup-location',
    templateUrl: './pickup-location.html',
    standalone: false
})
export class PickupLocationComponent extends PageBase implements OnInit {
  public bookingState: BookingModel;
  public rental: RentalInfo;

  public selectedLocation: LocationInfo;
  public locations: LocationInfo[];

  @ViewChild('map') public map: LocationMapComponent;

   
  constructor(private navigator: NavigationService, el: ElementRef,
    private aviationService: NavigationService, private rentalService: BookingService, public layoutService: LayoutService, private appService: AppIntegrationService, public appSettings: AppSettingsService) {
    super(el);
     
    this.bookingState = this.rentalService.getBookingState();
    this.rental = this.bookingState.booking;
    this.selectedLocation = this.rental.PickupLocation;
    
  }

  public async ngOnInit() {
    
    // Load all locations
    this.locations = await this.rentalService.getLocations();

    if (!this.selectedLocation) {
      var currentCoordinates = await this.appService.getCoordinates();

      if (currentCoordinates != null) {
        this.selectedLocation = this.rentalService.findClosestLocation(currentCoordinates.Latitude, currentCoordinates.Longitude);
      }
    }
  }



  public async selectLocation(): Promise<any> {
      this.rentalService.setPickupLocation(this.selectedLocation); 
      this.aviationService.executeCommand("Next");
  }
}
